import React from 'react';
import { CurrentItemPage } from '../../components/Views/CurrentItemPage';
import Layout from '../../components/Layout/Layout';
import { makeHostSum, normalizePath } from '../../utils/helpers';
import { getStaticData } from '../../utils/helpers/getStaticData';
import initApollo from '../../utils/init-Apollo';
import { getLocaleOnSSR } from '../../utils/helpers/getLocaleOnSSR';
import {
  getCurrentItemData,
  normalizeItemPagePath
} from '../../utils/helpers/item';
import { generateItemSeoObj } from '../../utils/helpers/seo';

const CurrentItem = props => <CurrentItemPage {...props} />;

export async function getServerSideProps({ res, req, params }) {
  const apolloClient = initApollo({}, { lang: getLocaleOnSSR(req) });
  const currentAsPath = normalizeItemPagePath(req.url);
  const newAsPath = normalizePath(currentAsPath);
  const hostSum = makeHostSum({ asPath: newAsPath, req });
  const itemId = params.id;

  const show404Page = response => {
    response.statusCode = 404;
    return { props: { statusCode: 404 } };
  };

  if (res && !currentAsPath.match(/\d+/)?.[0]) return show404Page(res);

  const [staticData, currentItemRes] = await Promise.all([
    getStaticData(apolloClient),
    getCurrentItemData(apolloClient, itemId)
  ]);

  const seoData = generateItemSeoObj(
    currentItemRes.currentItemData,
    newAsPath,
    hostSum
  );

  return {
    props: {
      newAsPath,
      hostSum,
      itemId,
      seoData,
      ...staticData,
      ...currentItemRes
    }
  };
}

CurrentItem.getLayout = (page, pageProps) => (
  <Layout
    isSafeAreaTop
    isBottomNavigation={false}
    isCurrentItemPage
    isBanner
    pageProps={pageProps}
    isBackgroundBanner
  >
    {page}
  </Layout>
);

export default CurrentItem;
